export const handleEmailLoginRequest = async (email, API_URL) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/email/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.detail || "Failed to send login code");
    }
    return { success: true };
  } catch (error) {
    console.error("Email login error:", error);
    return { error: error.message };
  }
};

export const verifyEmailCodeRequest = async (email, code, API_URL) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/email/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, code }),
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.detail || "Verification failed");
    }

    if (data.is_new) {
      return { isNew: true, provisionalUser: data.provisional_user };
    } else if (data.user) {
      return { isNew: false, user: data.user };
    } else if (data.status === "pending_approval") {
      return {
        error:
          "Your account is pending approval.\n\n" +
          "For new users, decision will be made within 3 business days.\n\n" +
          "If your account access has been revoked, email support@stackado.ai.",
      };
    } else {
      throw new Error("An unknown error occurred.");
    }
  } catch (error) {
    console.error("Email verification error:", error);
    return { error: error.message };
  }
};

export const handleOAuthTokenExchange = async (code, provider, redirectUri, API_URL) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, provider, redirect_uri: redirectUri }),
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.detail || "Token exchange failed");
    }

    if (data.is_new) {
      return { isNew: true, provisionalUser: data.provisional_user };
    } else if (data.user) {
      return { isNew: false, user: data.user };
    } else if (data.status === "pending_approval") {
      return {
        error:
          "Your account is pending approval.\n\n" +
          "For new users, decision will be made within 3 business days.\n\n" +
          "If your account access has been revoked, email support@stackado.ai.",
      };
    } else {
      throw new Error("An unknown error occurred.");
    }
  } catch (error) {
    console.error("OAuth callback error:", error);
    return { error: error.message };
  }
};

export const dismissTutorialRequest = async (API_URL) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/me/dismiss-tutorial`, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.detail || "Failed to dismiss tutorial");
    }
    return { success: true };
  } catch (error) {
    console.error("Dismiss tutorial error:", error);
    return { error: error.message };
  }
};

export const restoreTutorialRequest = async (API_URL) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/me/restore-tutorial`, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.detail || "Failed to restore tutorial");
    }
    return { success: true };
  } catch (error) {
    console.error("Restore tutorial error:", error);
    return { error: error.message };
  }
};

export const registerUserRequest = async (payload, API_URL) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "include",
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.detail || "Registration failed");
    }

    if (data.status === "pending_approval") {
      return {
        pending: true,
        message:
          "Registration successful! Your account is pending approval. " +
          "Decision will be made within 3 business days",
      };
    } else if (data.user) {
      return { success: true, user: data.user };
    } else {
      throw new Error("An unknown error occurred during registration.");
    }
  } catch (error) {
    console.error("Registration error:", error);
    return { error: error.message };
  }
};
